const firebaseConfig = {
  apiKey: "AIzaSyBstvVTFIH88zLX8jyYQR0qo1dTa7mPz68",
  authDomain: "tourism-assignment.firebaseapp.com",
  projectId: "tourism-assignment",
  storageBucket: "tourism-assignment.appspot.com",
  messagingSenderId: "870001209734",
  appId: "1:870001209734:web:e7cc5702123eef6d673c07"
};

export default firebaseConfig;
